<template>
  <div class="usage-card" :class="wrapperClasses">
    <v-card
      outlined
      height="188px"
      class="pa-4 d-flex justify-space-between flex-column"
    >
      <v-row no-gutters>
        <v-col cols="12" lg="12" class="d-flex justify-space-between">
          <div class="heading">
            <div class="font--secondary body-2 font-weight-600 ">
              {{ title }}
            </div>
            <div class="body-2 pt-1 ">{{ usageValue }}</div>
          </div>

          <slot name="chart"></slot>
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "UsageCard",
  /**
  |--------------------------------------------------
  | Props
  |--------------------------------------------------
  */
  props: {
    title: { type: String },
    usageValue: { type: String },
    wrapperClasses: { type: String, default: "" }
  }
};
</script>